<div class="linksection">
  <div class="row g-3 justify-content-center text-center">
    <div class="col-6 col-sm-6 col-md-3 border-end border-secondary">
      <a class="mainlink" queryParamsHandling="merge" type="button" routerLink="/company/contactus">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#fff" class="bi bi-headset"
          viewBox="0 0 16 16">
          <path
            d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5" />
        </svg>
        <br><br>{{ 'FOOTER.CONTACTUS' | translate }}</a>
    </div>
    <div class="col-6 col-sm-6 col-md-3 border-end border-secondary">
      <span data-bs-toggle="dropdown" role="presentation" type="button" class="text-white mainlink">
        <!-- <svg
          xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#fff" class="bi bi-cpu-fill"
          viewBox="0 0 16 16">
          <path d="M6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z" />
          <path
            d="M5.5.5a.5.5 0 0 0-1 0V2A2.5 2.5 0 0 0 2 4.5H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2A2.5 2.5 0 0 0 4.5 14v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14a2.5 2.5 0 0 0 2.5-2.5h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14A2.5 2.5 0 0 0 11.5 2V.5a.5.5 0 0 0-1 0V2h-1V.5a.5.5 0 0 0-1 0V2h-1V.5a.5.5 0 0 0-1 0V2h-1zm1 4.5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3A1.5 1.5 0 0 1 6.5 5" />
        </svg> -->
        <img ngSrc="assets/images/SVG/PX90 Icon 4.svg" alt="Products" style="height: 32px; width: 32px;" width="32" height="32">
        <br><br>{{ 'MISC.EXPLOREPROD' | translate }}&nbsp;<i class="bi bi-chevron-down"></i></span>
      <div role="menu" class="dropdown-menu">
        <a role="presentation" class="dropdown-item" [queryParams]="{ productcategory: 'catv' }"
          queryParamsHandling="merge" routerLink="/productcategory/catv">
          <h6 role="menuitem" class="m-0">{{ 'PRODUCTHEADER.CATEGORIES.CATV' | translate }}</h6>
        </a>
        <a role="presentation" class="dropdown-item" [queryParams]="{ productcategory: 'ethernet' }"
          queryParamsHandling="merge" routerLink="/productcategory/ethernet">
          <h6 role="menuitem" class="m-0">{{ 'PRODUCTHEADER.CATEGORIES.ETH' | translate }}</h6>
        </a>
        <a role="presentation" class="dropdown-item" [queryParams]="{ productcategory: 'fiberoptics' }"
          queryParamsHandling="merge" routerLink="/productcategory/fiberoptics">
          <h6 role="menuitem" class="m-0">{{ 'PRODUCTHEADER.CATEGORIES.FIBER' | translate }}</h6>
        </a>
        <a role="presentation" class="dropdown-item" [queryParams]="{ productcategory: 'transportmetrocore' }"
          queryParamsHandling="merge" routerLink="/productcategory/transport">
          <h6 role="menuitem" class="m-0">{{ 'PRODUCTHEADER.CATEGORIES.TRANMETCOR' | translate }}</h6>
        </a>
        <a role="presentation" class="dropdown-item" [queryParams]="{ productcategory: 'wifi' }"
          queryParamsHandling="merge" routerLink="/productcategory/wifi">
          <h6 role="menuitem" class="m-0">{{ 'PRODUCTHEADER.CATEGORIES.WIFI' | translate }}</h6>
        </a>
        <a role="presentation" class="dropdown-item" [queryParams]="{ productcategory: 'dsl' }"
          queryParamsHandling="merge" routerLink="/productcategory/dsl">
          <h6 role="menuitem" class="m-0">{{ 'PRODUCTHEADER.CATEGORIES.DSLCOP' | translate }}</h6>
        </a>
      </div>

    </div>
    <div class="col-6 col-sm-6 col-md-3 border-end border-secondary">
      <a class="mainlink" queryParamsHandling="merge" type="button" routerLink="/company/howtobuy">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#fff" class="bi bi-cart-fill"
          viewBox="0 0 16 16">
          <path
            d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
        </svg><br><br>
        {{ 'LANDING.HOWTOBUYTILE' | translate }}</a>
    </div>
    <div class="col-6 col-sm-6 col-md-3">
      <a class="mainlink" queryParamsHandling="merge" type="button"
        routerLink="/newsandevents/webinars">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#fff" class="bi bi-play-btn-fill" viewBox="0 0 16 16">
  <path d="M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2m6.79-6.907A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z"/>
</svg><br><br>
{{ 'FOOTER.WEBINARS' | translate }}</a>
    </div>
  </div>
</div>
